<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormAgenda" role="form" method="post" autocomplete="off" onSubmit="return false">	

					<div class="form-group row" v-if="ObjCliente.Lugar != 'ListadoAgenda'">
						<div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
							<label class="form-label" for="NombreCliente">Cliente</label>
							<div class="input-group">
								<input type="text" v-model="ObjCliente.Nombres" @input="BuscarCliente()" class="form-control" id="NombreCliente" placeholder="Ingresar Cliente" :readonly="SearchBloq.Read"/>
								<button type="button" @click="BuscarCliente()" class="btn btn-outline-primary boder-extend" id="button-addon2">
									<i v-show="SearchBloq.Icono == 1" class="fa fa-search"></i>
									<i v-show="SearchBloq.Icono == 2" class="spinner-border spinner-border-sm"></i>
									<i v-show="SearchBloq.Icono == 3" class="fa fa-trash"></i>
								</button>
							</div>
							<ul class="busqueda list-group" id="ulcli">
                                <li v-for="(item,index) in ListaClientes" @click="SeleccionarItem(item);" :key="index" class="bss list-group-item">{{item.Nombres}}</li>
                            </ul>
							<CValidation v-if="this.errorvalidacion.IdCliente" :Mensaje="'*'+errorvalidacion.IdCliente[0]"/>
						</div>
					</div>

					<div class="form-group row" v-if="ObjCliente.Lugar == 'ListadoAgenda'">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Cliente">Prospecto(s) - Cliente(s)</label>
							<input type="text" v-model="ObjCliente.Nombres" class="form-control" id="Cliente" readonly/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
							<label class="form-label" for="IdAccion">Acción</label>
							<select v-model="objAgenda.IdAccion" @change="GetTextoAccion()" class="form-control form-select" id="IdAccion">
								<option value="0">Seleccione una opción</option>
								<option v-for="(item,index) in ListaAcciones" :key="index" :value="item.IdAccion">
									{{item.Nombre}}
								</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdAccion" :Mensaje="'*'+errorvalidacion.IdAccion[0]"/>
						</div>
						
						<div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
							<label class="form-label" for="Asunto">Asunto</label>
							<input type="text" v-model="objAgenda.Asunto" class="form-control" id="Asunto" placeholder="Ingresar Asunto" />
							<CValidation v-if="this.errorvalidacion.Asunto" :Mensaje="'*'+errorvalidacion.Asunto[0]"/>
						</div>
					</div>
					
					<div class="form-group row" v-show="!ShowTextEditor">
						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
							<label class="form-label" for="Fecha">Fecha</label>
							<div class="calendar">
								<Datepicker v-model="objAgenda.Fecha" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00" ref="FE"></Datepicker>
							</div>
							<CValidation v-if="this.errorvalidacion.Fecha" :Mensaje="'*'+errorvalidacion.Fecha[0]"/>
						</div>
						
						<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
							<label class="form-label" for="HoraIni">Hora Inicio</label>
							<div class="clock">
								<vue-clock-picker v-model="objAgenda.HoraIni" @input="ValidarHoras('HI')" :input-class="'form-control'" :done-text="'Listo'" :cancel-text="'Cancelar'" placeholder="00:00"></vue-clock-picker>
							</div>
							<CValidation v-if="this.errorvalidacion.HoraIni" :Mensaje="'*'+errorvalidacion.HoraIni[0]"/>
						</div>
						
						<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
							<label class="form-label" for="HoraFin">Hora Fin</label>
							<div class="clock">
								<vue-clock-picker v-model="objAgenda.HoraFin" @input="ValidarHoras('HF')" :input-class="'form-control'" :done-text="'Listo'" :cancel-text="'Cancelar'" placeholder="00:00"></vue-clock-picker>
							</div>
							<CValidation v-if="this.errorvalidacion.HoraFin" :Mensaje="'*'+errorvalidacion.HoraFin[0]"/>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Contenido">Contenido</label>
							<textarea v-model="objAgenda.Contenido" class="form-control" id="Contenido" placeholder="Ingresar Contenido" rows="5"></textarea>
							<CValidation v-if="this.errorvalidacion.Contenido" :Mensaje="'*'+errorvalidacion.Contenido[0]"/>
						</div>
					</div>
					
					
					<div class="form-group row" v-show="!ShowTextEditor">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Recordatorio">Recordatorio</label>
							<div class="form-check">
								<input class="form-check-input" type="checkbox" v-model="objAgenda.Recordatorio" id="Recordatorio">
								<label class="form-check-label" for="Recordatorio">
									Marcar
								</label>
							</div>
						</div>
					</div>
											
					<br>
					
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>
import moment from 'moment';
import Calendar from '@/helpers/StaticComboBox.js';

export default {
    name: 'FormAgenda',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objAgenda: {
				IdAgenda: 0,
				Contenido: '',
				IdCliente: 0,
				IdCotizacion: 0,
				IdUsuario: 0,
				IdAccion: 0,
				Fecha: '',
				HoraIni: '',
				HoraFin: '',
				Asunto: '',
				Recordatorio: '',
				IdEmpresa: '',
				IdSucursal: '',
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			Setpicker: Calendar.calendarSettings,
			ListaAcciones: [],
			ListaClientes: [],
			ShowTextEditor: false,
			ObjCliente: {
				Lugar: '',
				Nombres: '',
				IdCliente: '',
				IdCotizacion: '',
			},
			SearchBloq: {
				Icono: 1,
				Read: false,
			},
			TimeOutSearch: null,
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objAgenda.Fecha!=''){
				this.objAgenda.Fecha = moment(this.objAgenda.Fecha).format('YYYY-MM-DD');
			}
			
			let AccionAgenda = '';
			let IdAccion = this.objAgenda.IdAccion;
			let resp = this.ListaAcciones.filter(function(element){
				return (IdAccion == element.IdAccion) ? element : '';
			});

			if(resp[0]){
				AccionAgenda = resp[0].Nombre;
			}

			this.objAgenda.IdCliente = this.ObjCliente.IdCliente
			this.objAgenda.Accion = AccionAgenda;

			if(this.objAgenda.IdAgenda == 0) {
				await this.$http.post(
					'agendas',this.objAgenda
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'agendas/'+this.objAgenda.IdAgenda,
					this.objAgenda
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);

			if(this.ObjCliente.Lugar !='ListadoAgenda')
			{
				this.bus.$emit('reloadCalendar');
			}
			else
			{
            	this.bus.$emit('List_'+this.Emit);
			}
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "agendas/"+this.objAgenda.IdAgenda
            ).then((res) => {
                this.objAgenda = res.data.data;

				// MARCAMOS EL CHECK DEL RECORDATORIO
				if(res.data.data.Recordatorio == 'SI'){
					this.objAgenda.Recordatorio = true;
				}
				else{
					this.objAgenda.Recordatorio = false;
				}

				// SI ES LA VIDA DEL CALENDARIO BLOQUEAMOS LA BUSQUEDA DEL USUARIO
				if(this.ObjCliente.Lugar != 'ListadoAgenda')
				{
					this.SearchBloq.Read = true;
					this.SearchBloq.Icono = 3;
				}

				// VALIDAREMOS LA FECHA ACTUAL PARA IMPEDIR HACER CORRECCIONES
				let FechaAgenda = this.objAgenda.Fecha;
				
				if(FechaAgenda!='')
				{
					let FechaTransform = moment(FechaAgenda).format('YYYY-MM-DD');
					let valuesStart = FechaTransform.split("-");
					FechaAgenda = new Date(valuesStart[0],(valuesStart[1]-1),valuesStart[2]);
				}

				let FechaTransform2 = moment(new Date()).format('YYYY-MM-DD');
				let valuesStart2 = FechaTransform2.split("-");
				let Today = new Date(valuesStart2[0],(valuesStart2[1]-1),valuesStart2[2]);

				if(Today>FechaAgenda){
					this.poBtnSave.ShowBtnSave = false;
				}
				else{
					this.poBtnSave.ShowBtnSave = true;
				}

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objAgenda = {
				IdAgenda: 0,
				Contenido: '',
				IdCliente: 0,
				IdCotizacion: 0,
				IdUsuario: 0,
				IdAccion: 0,
				Fecha: '',
				HoraIni: '',
				HoraFin: '',
				Asunto: '',
				Recordatorio: '',
				IdEmpresa: '',
				IdSucursal: '',				
            }
            this.errorvalidacion = [];
        },
		GetListAcciones()
		{
			this.$http.get(
                "acciones"
            ).then((res) => {
                this.ListaAcciones 	= res.data.data.data;

            }).finally(()=>{
                //this.ConfigLoad.ShowLoader = false;
            });
		},
		GetTextoAccion()
		{
			let Buscar = this.objAgenda.IdAccion;
			let arr = this.ListaAcciones.filter(function(element){
				if(element.IdAccion == Buscar){
					return element;
				}
				else{
					return '';
				}
			});

			if(arr[0])
			{
				if(arr[0].Nombre == 'Correo'){
					this.ShowTextEditor = true;
					this.$refs.FE.clearDate();
					this.objAgenda.Fecha = '';
					this.objAgenda.HoraIni = '';
					this.objAgenda.HoraFin = '';
					this.objAgenda.Recordatorio = false;
				}
				else{
					this.ShowTextEditor = false;
				}
			}
			else{
				this.ShowTextEditor = false;
			}
		},
		ValidarHoras(cmp)
		{
			let Hini = this.objAgenda.HoraIni;
			let Hfin = this.objAgenda.HoraFin;
			let FechaTransform = moment(new Date()).format('YYYY-MM-DD');

			if(Hini!=''){
				Hini = new Date(FechaTransform+' '+Hini+':00');
			}

			if(Hfin!=''){
				Hfin = (Hfin == '00:00')?'23:59':Hfin;
				Hfin = new Date(FechaTransform+' '+Hfin+':00');
			}

			if(Hini!='' && Hfin!='')
			{
				if(Hfin<=Hini)
				{
					this.$toast.warning('La hora final debe ser mayor a la hora inicial');
					if(cmp == 'HI'){
						this.objAgenda.HoraIni = '';
					}
					else{
						this.objAgenda.HoraFin = '';
					}
					return false;
				}
			}
		},
		BuscarCliente()
		{
			if(this.SearchBloq.Icono == 1)
			{
				clearTimeout(this.TimeOutSearch);
				this.SearchBloq.Icono = 2;

				this.TimeOutSearch = setTimeout(() => {
                	this.RealizarBusqueda();
            	}, 1000);
			}
			else if(this.SearchBloq.Icono == 3)
			{
				this.SearchBloq.Icono = 1;
				this.SearchBloq.Read = false;
				this.ObjCliente.Nombres = '';
				this.ObjCliente.IdCliente = 0;
			}
		},
		RealizarBusqueda()
		{
			this.SearchBloq.Icono = 2;
			this.$http.get("clientes",{
				params:{
					TxtBusqueda: this.ObjCliente.Nombres,
					Simple: 1,
				}
			}).then((res) => {
                this.ListaClientes = res.data.data;

            }).finally(()=>{
                this.SearchBloq.Icono = 1;
            });
		},
		SeleccionarItem(item)
		{
			this.SearchBloq.Icono = 3;
			this.SearchBloq.Read = true;
			this.ObjCliente.Nombres = item.Nombres;
			this.ObjCliente.IdCliente = item.IdCliente;
			this.ListaClientes = [];
		}
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id,obj)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
			this.GetListAcciones();
			console.log(obj)
			if (Object.keys(obj).length !== 0)
			{
				if(obj.Lugar == 'ListadoAgenda')
				{
					this.ObjCliente.Lugar = obj.Lugar;
					this.ObjCliente.Nombres = obj.ObjCliente.Nombres;
					this.ObjCliente.IdCliente = obj.ObjCliente.IdCliente;
				}
				else
				{
					this.ObjCliente.Lugar = obj.Lugar;
					this.ObjCliente.Nombres = obj.Nombres;
					this.ObjCliente.IdCliente = obj.IdCliente;
				}
			}
                
            if (Id!='') 
            {
                this.objAgenda.IdAgenda = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
				this.poBtnSave.ShowBtnSave = true;
            }
        });
    }
}
</script>
